export class GcpDiskTypesResponse {
    'diskTypes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "diskTypes",
            "baseName": "diskTypes",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpDiskTypesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
